// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-uploader[data-v-9c2bd7be]{display:block}.tips[data-v-9c2bd7be]{font-size:16px;color:#1989fa}.right p[data-v-9c2bd7be]{font-size:12px;margin:2px 0 2px}.bottom p[data-v-9c2bd7be]{border-top:1px solid #1989fa;margin:10px 10%;font-size:16px;padding-bottom:10px}.bottom p[data-v-9c2bd7be],footer[data-v-9c2bd7be]{width:80%;text-align:center}footer[data-v-9c2bd7be]{bottom:5px;position:relative;margin:5px 10%}[data-v-9c2bd7be]:export{green:#1989fa;white:#fff}", ""]);
// Exports
module.exports = exports;
